module.exports = __webpack_public_path__ + "static/media/15UN-Habitat8.2bd3eb6d.jpg";